import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import store from 'root-js/store';

let isInitialized = false;

const logError = (message, error) => {
    if (process.env.NODE_ENV !== 'production') {
        console.error(message, error);
    }
};

let lastSyncedToken = null;
let lastSyncedUserId = null;

const syncDeviceToken = async token => {
    
    const currentUserId = store.getters['user/user']?.id;


    if (!token || !store.getters['auth/token'] || !window.api) {
        return;
    }

   
    

    if (token === lastSyncedToken && currentUserId === lastSyncedUserId) {
        return;
    }

    try {
        const payload = { device_token: token };
        const response = await window.api.call('update-device-token', payload);
        
        lastSyncedToken = token;
        lastSyncedUserId = currentUserId;
    } catch (error) {
        logError('Device token sync failed:', error);
    }
};

export const checkPushPermissionsStatus = async () => {
    if (Capacitor.getPlatform() !== 'ios') {
        return 'denied';
    }
    const status = await PushNotifications.checkPermissions();
    return status.receive; // 'prompt', 'granted', 'denied'
};

export const registerListenersAndSyncIfGranted = async () => {
    if (isInitialized || Capacitor.getPlatform() !== 'ios') {
        return;
    }

    isInitialized = true;

    try {
        // Force cleanup to prevent memory leaks from duplicate native listeners during hot reloads or state resets
        await PushNotifications.removeAllListeners();

        await PushNotifications.addListener('registration', token => {
            store.commit('auth/SET_APNS_TOKEN', token.value);
            syncDeviceToken(token.value);
        });

        await PushNotifications.addListener('registrationError', error => {
            logError('APNS registration failed:', error);
        });

        await PushNotifications.addListener('pushNotificationReceived', notification => {
            void notification;
        });

        await PushNotifications.addListener('pushNotificationActionPerformed', action => {
            void action;
        });

        // Silently register if permission was already granted previously
        const status = await PushNotifications.checkPermissions();
        if (status.receive === 'granted') {
            
            // Explicitly sync the stored token immediately instead of relying solely on the native registration event
            const existingToken = store.getters['auth/apnsToken'];
            if (existingToken) {
                syncDeviceToken(existingToken);
            }

            await PushNotifications.register();
        }
    } catch (error) {
        isInitialized = false;
        logError('Push notification initialization failed:', error);
    }
};

export const requestPermissionsAndRegister = async () => {
    if (Capacitor.getPlatform() !== 'ios') {
        return false;
    }

    try {
        let permissionStatus = await PushNotifications.checkPermissions();

        if (permissionStatus.receive === 'prompt') {
            permissionStatus = await PushNotifications.requestPermissions();
        }

        if (permissionStatus.receive !== 'granted') {
            return false;
        }

        await PushNotifications.register();
        return true;
    } catch (error) {
        logError('Push notification permission request failed:', error);
        return false;
    }
};

// src/js/services/PushNotificationService.js
export const syncIfGrantedForCurrentUser = async () => {
  if (Capacitor.getPlatform() !== 'ios') return;

  const status = await PushNotifications.checkPermissions();
  if (status.receive !== 'granted') return;

  
  
  const existingToken = store.getters['auth/apnsToken'];
  if (existingToken) {
    await syncDeviceToken(existingToken);
  }
};

